<template>
  <div v-if="screener.qa_info && screener.qa_info.title" class="pt-2">
    <div class="secondary--text py-2">
      <!-- Link -->
      <span class="title font-weight-bold pb-1">{{
        screener.qa_info.title
      }}</span>
      <!-- Message -->
      <div v-if="screener.qa_info.message">{{ screener.qa_info.message }}</div>
      <a
        v-if="screener.qa_info.zoom_link"
        class="secondary--text"
        :href="screener.qa_info.zoom_link"
        target="_blank"
        >{{ screener.qa_info.zoom_link }}</a
      >
      <!-- Meeting ID & password -->
      <div v-if="screener.qa_info.meeting_id && screener.qa_info.password">
        <div>
          <div class="d-inline-block subheading">
            {{ $t("screener.zoom.meeting_id") }}
          </div>
          <div class="d-inline-block px-1">:</div>
          <div class="d-inline-block subheading font-weight-bold grey--text">
            {{ screener.qa_info.meeting_id }}
          </div>
        </div>
        <div>
          <div class="d-inline-block subheading">
            {{ $t("screener.zoom.password") }}
          </div>
          <div class="d-inline-block px-1">:</div>
          <div class="d-inline-block subheading font-weight-bold grey--text">
            {{ screener.qa_info.password }}
          </div>
        </div>
      </div>
    </div>
  </div>
</template>

<script>
export default {
  name: "ZoomInfo",
  props: {
    screener: {
      type: Object,
      default: null
    }
  }
};
</script>

<style>
</style>
